import { createContext, useEffect, useReducer } from "react";
import { useDispatch } from "react-redux";
import axios from "../utils/axios";
import { setSession } from "../utils/token";

import {
  getActiveRmk,
  getRmkActiveApplication,
} from "../redux/slices/rmk-information/rmkSlice";
import { fetchUser, resetUserReducer } from "../redux/slices/userSlice";
import { resetProjectsReducer } from "../redux/slices/projects/projectsSlice";
import { resetUsersReducer } from "../redux/slices/usersSlice";
import { resetDashboardReducer } from "../redux/slices/dashboard/dashboardSlice";
import { useLocation, useNavigate } from "react-router-dom";
import { setIsLoading } from "../redux/slices/userSlice";

import OAuthInfo from "@arcgis/core/identity/OAuthInfo";
import IdentityManager from "@arcgis/core/identity/IdentityManager";

const INITIALIZE = "INITIALIZE";
const SIGN_IN = "SIGN_IN";
export const SIGN_OUT = "SIGN_OUT";
const SIGN_UP = "SIGN_UP";

const initialState = {
  isAuthenticated: false,
  isInitialized: false,
  user: null,
};

const AuthReducer = (state, action) => {
  switch (action.type) {
    case INITIALIZE:
      return {
        isAuthenticated: action.payload.isAuthenticated,
        isInitialized: true,
        user: action.payload.user,
      };
    case SIGN_IN:
      return {
        ...state,
        isAuthenticated: true,
        user: action.payload.user,
      };
    case SIGN_OUT:
      return {
        ...state,
        isAuthenticated: false,
        user: null,
      };

    case SIGN_UP:
      return {
        ...state,
        isAuthenticated: true,
        user: action.payload.user,
      };

    default:
      return state;
  }
};

const AuthContext = createContext(null);

function AuthProvider({ children }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const [state, setState] = useReducer(AuthReducer, initialState);

  useEffect(() => {
    const initialize = async () => {
      try {
        const accessToken = window.localStorage.getItem("accessToken");

        if (accessToken) {
          setSession(accessToken);
          const response = await axios.get("/user", {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          });

          const { user } = response.data;

          const roles = user.roles || [];

          dispatch(setIsLoading(true));

          setState({
            type: INITIALIZE,
            payload: {
              isAuthenticated: true,
              user,
            },
          });
          const userAuth = {
            ...user,
          };

          await dispatch(fetchUser(userAuth));
          await dispatch(getRmkActiveApplication());
          await dispatch(getActiveRmk());

          let redirectPath = "/auth/404"; // Default path

          if (location.pathname === "/") {
            if (roles.includes("superadmin")) {
              redirectPath = "/pengumuman";
            }
            if (roles.includes("pengumuman")) {
              redirectPath = "/pengumuman";
            }
            if (roles.includes("dashboard")) {
              redirectPath = "/pengumuman";
            }
            if (roles.includes("laporan_prestasi_projek")) {
              redirectPath = "/pengumuman";
            }
            if (roles.includes("projek_mikro_dashboard")) {
              redirectPath = "/projek-mikro/dashboard";
            }
            if (roles.includes("projek_mikro_senarai")) {
              redirectPath = "/projek-mikro/senarai-projek";
            }
            if (roles.includes("projek_mikro_status_senarai")) {
              redirectPath = "/projek-mikro/status-senarai-projek";
            }
            if (roles.includes("admin_projek_mikro")) {
              redirectPath = "/projek-mikro/admin/senarai-pengguna";
            }
          } else {
            redirectPath = location.pathname;
          }

          // const info = new OAuthInfo({
          //   appId: "TEvYHd3nhPCZbW5Q", // Replace with your client ID
          //   portalUrl: "https://smepps-geo.sabah.gov.my/arcgis",
          //   popup: false, // Enable popup for authentication
          //   preserveUrlHash: true,
          // });

          // IdentityManager.registerOAuthInfos([info]);

          // Authenticate in a popup window
          // IdentityManager.getCredential(info.portalUrl + "/sharing", {
          //   oAuthPopupConfirmation: false,
          // })
          //   .then((credential) => {
          //     sessionStorage.setItem(
          //       "esriCredential",
          //       JSON.stringify(credential),
          //     );
          //   })
          //   .catch((error) => {
          //     console.error("Esri Authentication failed: ", error);
          //   });

          setTimeout(() => {
            dispatch(setIsLoading(false));
            navigate(redirectPath);
          }, 2000);
        } else {
          setState({
            type: INITIALIZE,
            payload: {
              isAuthenticated: false,
              user: null,
            },
          });
        }
      } catch (err) {
        console.error(err);
        setState({
          type: INITIALIZE,
          payload: {
            isAuthenticated: false,
            user: null,
          },
        });
      }
    };

    initialize();

    return () => {
      setState({});
    };
  }, [dispatch]);

  const signIn = async (user, token) => {
    setSession(token);
    setState({
      type: SIGN_IN,
      payload: {
        user,
      },
    });

    await dispatch(fetchUser(user));
    await dispatch(getRmkActiveApplication());
    await dispatch(getActiveRmk());

    const roles = user.roles || [];
    const isTrue = user.first_time_login;

    dispatch(setIsLoading(true));

    let redirectPath = "/auth/404"; // Default path

    if (isTrue) {
      redirectPath = "/tukar-kata-laluan";
    } else {
      if (roles.includes("superadmin")) {
        redirectPath = "/pengumuman";
      }
      if (roles.includes("dashboard")) {
        redirectPath = "/pengumuman";
      }
      if (roles.includes("laporan_prestasi_projek")) {
        redirectPath = "/pengumuman";
      }
      if (roles.includes("projek_mikro_dashboard")) {
        redirectPath = "/projek-mikro/dashboard";
      }
      if (roles.includes("projek_mikro_senarai")) {
        redirectPath = "/projek-mikro/senarai-projek";
      }
      if (roles.includes("projek_mikro_status_senarai")) {
        redirectPath = "/projek-mikro/status-senarai-projek";
      }
      if (roles.includes("admin_projek_mikro")) {
        redirectPath = "/projek-mikro/admin/senarai-pengguna";
      }

      // const info = new OAuthInfo({
      //   appId: "TEvYHd3nhPCZbW5Q", // Replace with your client ID
      //   portalUrl: "https://smepps-geo.sabah.gov.my/arcgis",
      //   popup: false, // Enable popup for authentication
      //   preserveUrlHash: true,
      // });

      // IdentityManager.registerOAuthInfos([info]);

      // // Authenticate in a popup window
      // IdentityManager.getCredential(info.portalUrl + "/sharing", {
      //   oAuthPopupConfirmation: false,
      // })
      //   .then((credential) => {
      //     sessionStorage.setItem("esriCredential", JSON.stringify(credential));
      //   })
      //   .catch((error) => {
      //     console.error("Esri Authentication failed: ", error);
      //   });
    }

    setTimeout(() => {
      dispatch(setIsLoading(false));
      navigate(redirectPath);
    }, 2000);

    const userAuth = {
      ...user,
    };

    return userAuth;
  };

  const handleResetReducer = () => {
    dispatch(resetUserReducer());
    dispatch(resetProjectsReducer());
    dispatch(resetUsersReducer());
    dispatch(resetDashboardReducer());
  };

  const signOut = async () => {
    const response = await axios.post("/auth/logout");
    setSession(null);
    localStorage.removeItem("accessToken");
    sessionStorage.clear();
    setState({ type: SIGN_OUT });
    handleResetReducer();
  };

  const resetPassword = (email) => console.log(email);

  return (
    <AuthContext.Provider
      value={{
        ...state,
        signIn,
        signOut,
        resetPassword,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export { AuthContext, AuthProvider };
